import {Maybe} from '@coolcolduk/typescript-util';
import {ReactNode} from 'react';
import {User} from '@cp/model';
import LoadingPage from '../pages/other/LoadingPage';

export interface BranchRouteProps {
  user: Maybe<User> | undefined;
  privateRoute: ReactNode;
  publicRoute: ReactNode;
  userUndefinedLoading?: boolean;
}

export default function BranchRoute({user, privateRoute, publicRoute, userUndefinedLoading = false}: BranchRouteProps) {
  if (userUndefinedLoading && user === undefined) {
    return <LoadingPage />;
  }

  return user ? privateRoute : publicRoute;
}
